<template>
  <div class="el-home">
    <!-- 学生 -->
    <StudentHome v-if="userType == 1"></StudentHome>
    <!-- 教师 -->
    <TeacherHome v-if="userType == 2"></TeacherHome>
  </div>
</template>

<script>
import StudentHome from "./Student/Home";	//学生端首页
import TeacherHome from "./Teacher/Home";	//教师端首页
export default {
  name: "Home",
  components: {
    StudentHome,
    TeacherHome,
  },
  data() {
    return {
      userType:this.$Base64.decode(this.$ls.get(this.$getKeyInfo("userType"))),
      timeIn:null
    };
  },
  created() {
    //this.addSystem();
  },
  mounted() {

  },
  methods: {
    addSystem(){ //模块使用统计
      //模块使用时间 开始
      const timeNum = this.$ls.get('timeNum'); //获取统一
      this.timeIn = setInterval(()=>{
        let param = {
          firstName:"首页",//一级名称
          secondName:"首页",//二级名称
          useDuration:timeNum / 1000 / 60//单次使用时长（单位：分钟）
        }
        this.$addSystemUseLog(param);
      },timeNum);
      // 结束
    }
  },
  beforeDestroy() {
    clearInterval(this.timeIn); //关闭定时
  }
};
</script>
 <style  lang="less">

</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/pages/Home.vue